// @flow
import React, { type Node, useMemo, useEffect } from 'react';
import { pipe, map, sort, ascend, prop, propEq, isEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';

import { identifiersNames, type IdentifierType } from 'app/common/constants/identifiers';
import PlainFieldset from 'app/common/ui-next/plain-fieldset';

import IdentifierFormItem from './identifier-form-item';
import styles from './identifier-form-items.module.scss';;


type Props = {
  availableIdentifierTypes?: Array<IdentifierType>,
  onChange?: (type: IdentifierType) => void,
  currentType: IdentifierType | null,
}

const IdentifierFormItems = ({
  availableIdentifierTypes,
  onChange,
  currentType,
}: Props): Node => {
  const { t } = useTranslation('identifiers-next');

  const items: Array<{ type: IdentifierType, title: string }> = useMemo(() => {
    return pipe(
      map(type => ({ type, title: identifiersNames[type] || 'Неизвестный тип идентификатора' })),
      sort(ascend(prop('title'))),
    )(availableIdentifierTypes);
  }, [availableIdentifierTypes]);

  useEffect(() => {
    if (!currentType || !items.find(propEq('type', currentType))) {
      if (onChange && !isEmpty(items)) {
        onChange(items[0].type);
      }
    }
  }, [items]);


  return (
    <PlainFieldset
      legend={t('add_identifier_items_label', 'Выберите тип идентификатора:')}
      className={styles.root}
      name="identifiers"
      skipUpperSpace
    >
      {items.map(({ type, title }) => (
        <IdentifierFormItem
          key={type}
          type={type}
          label={title}
          checked={currentType === type}
          onChange={onChange}
        />
      ))}
    </PlainFieldset>
  );
};

export default IdentifierFormItems;
